import Vue from 'vue';
import RestX from '../RestX';

// Plugins and template functions
import Token from '~/api/Token';

import createPersistedState from 'vuex-persistedstate';

// Module imports
import posting from './modules/postingModule';
import company from './modules/companyModule';
import profile from './modules/profileModule';
import school from './modules/schoolModule';
import degree from './modules/degreeModule';
import token from './modules/tokenModule';
import companyFollow from './modules/companyFollowModule';
import user from './modules/userModule';
import university from './modules/universityModule';
import complete from './modules/suggestionModule';
import event from './modules/eventModule';
import candidate from './modules/candidateModule';
import organization from './modules/organizationModule';
import identity from './modules/identityModule';
import resources from './modules/resourceModule';
import calendar from './modules/calendarModule';

import autocomplete from './modules/autocompleteModule';

// Custom Module imports
import logInModule from './customModules/logInModule';
import unsavedChanges from './customModules/unsavedChanges';
import dialogModal from './customModules/dialogModal';
import messageModule from './customModules/messageModule';
import scrollState from './customModules/scrollState';
import floatingActionButton from './customModules/floatingActionButton';
import uniBadgeModule from './customModules/uniBadgeModule';
import localeModule from './customModules/localeModule';
import fakeLoad from './customModules/fakeLoad';
import favoriteModule from './customModules/favoriteModule';

// Middleware imports
import {
    getAccessByRefresh,
    shouldRefreshToken,
} from './middlewares/refreshToken';

Vue.use(RestX);

RestX.registerTemplateFunctions({
    shouldRefreshToken: shouldRefreshToken,
    getAccessByRefresh: getAccessByRefresh,
    setRefreshToken: refreshToken => Token.setRefresh(refreshToken),
    setToken: token => Token.setAccess(token),
    getAuthToken: () => Token.getAccess(),
    isAuthenticated: () => Token.isAuthenticated(),
});

RestX.registerPlugins([
    createPersistedState({
        paths: ['localeModule.locale', 'user' /*, 'company' */], // Currently there is no support for timeouts on localstored data...
        filter: mutation =>
            mutation.type === 'localeModule/setLocaleItem' ||
            mutation.type.startsWith('user') ||
            mutation.type.startsWith('company'),
    }),
]);

RestX.createCustomModule('logInModule', logInModule);
RestX.createCustomModule('unsavedChanges', unsavedChanges);
RestX.createCustomModule('dialogModal', dialogModal);
RestX.createCustomModule('messageModule', messageModule);
RestX.createCustomModule('scrollState', scrollState);
RestX.createCustomModule('floatingActionButton', floatingActionButton);
RestX.createCustomModule('uniBadgeModule', uniBadgeModule);
RestX.createCustomModule('localeModule', localeModule);
RestX.createCustomModule('fakeLoad', fakeLoad);
RestX.createCustomModule('favoriteModule', favoriteModule);

export default RestX.createStore(
    {
        posting,
        company,
        user,
        candidate,
        profile,
        school,
        degree,
        token,
        companyFollow,
        complete,
        event,
        university,
        organization,
        identity,
        autocomplete,
        resources,
        calendar,
    }
    // , console
);
